import { Checkbox, FormControlLabel, Grid, Typography } from "@mui/material";
import AcxSelectMulti from "components/UI/Select/BaseSelectComponents/AcxSelectMulti";
import { observer } from "mobx-react";
import React from "react";
import { AuthStore } from "stores/AuthStore";
import { OrganizationServiceHierarchyStore } from "../stores/OrganizationServiceHierarchyStore";

interface OsmHierarchyMetadataLayoutProps {
    osmStore: OrganizationServiceHierarchyStore;
    authStore: AuthStore;
}

const OsmHierarchyMetadataLayout: React.FC<OsmHierarchyMetadataLayoutProps> =
    observer(({ osmStore, authStore }) => {
        const hasEditPerms = authStore.canUserEdit("Service Hierarchy");
        const descendantCount = osmStore.activeTier?.descendantCount ?? 0;

        return (
            <Grid container item xs={12} spacing={1} sx={{ padding: "1rem 0" }}>
                <Grid item xs={12}>
                    <AcxSelectMulti
                        key={osmStore.activeTier?.id ?? "therapeutic-area"}
                        id="select-therapeutic-area"
                        options={osmStore.therapeuticAreas ?? []}
                        defaultValue={osmStore.activeTier?.therapeuticAreas ?? []}
                        inputLabel="Therapeutic Area"
                        valueField="id"
                        labelField="name"
                        containerHeight="auto"
                        fullWidth
                        isClearable
                        isLoading={osmStore.isLoading}
                        isDisabled={!hasEditPerms}
                        placeholder="Select..."
                        onChange={(areas) =>
                            osmStore.setActiveTierAttribute(
                                "therapeuticAreas",
                                areas ?? [],
                            )
                        }
                    />
                </Grid>

                <Grid
                    item
                    xs={12}
                    sx={{
                        alignItems: "center",
                        backgroundColor: "#F8FAFC",
                        borderRadius: "4px",
                        display: "flex",
                        justifyContent: "space-between",
                        marginTop: 0.5,
                        padding: "0.25rem 0.75rem",
                    }}
                >
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={
                                    osmStore.applyTherapeuticAreasToChildren
                                }
                                disabled={!hasEditPerms || descendantCount === 0}
                                onChange={(event) =>
                                    osmStore.setApplyTherapeuticAreasToChildren(
                                        event.target.checked,
                                    )
                                }
                                size="small"
                            />
                        }
                        label="Apply to all children"
                    />
                    <Typography color="text.secondary" variant="body2">
                        {descendantCount} nodes
                    </Typography>
                </Grid>
            </Grid>
        );
    });

export default OsmHierarchyMetadataLayout;
